import schwarzwaldData from "./raw/schwarzwald.json";

export const schwarzwaldColorMap = (type) => {
  if (type === "range") {
    return schwarzwaldData;
  }
};
